// Canonical/SEO base URL.
// - If REACT_APP_SITE_URL is set (e.g. https://eventcity.app once the custom
//   domain is live), use it as the single canonical domain.
// - Otherwise auto-detect the domain the app is actually served from, so SEO
//   tags never point at a domain that isn't live yet.
const envSite = (process.env.REACT_APP_SITE_URL || "").trim().replace(/\/$/, "");
export const SITE_URL =
  envSite || (typeof window !== "undefined" ? window.location.origin : "");

export const OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/7e2ea8e8-7191-4399-8be8-44736b099c16/images/3d3bc4527f076a0ede3746bea07dc5641c3891cd1ee2526f0622531a30c4fcba.png";

export const SITE_NAME = "Event City";
